import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { useCallback, useRef, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import featureFlags from '@/config/features';
import userInteractions from '@/services/localStorage/userInteractions';
import ClientOnly from '@/components/ClientOnly';
import { ButtonV2 as Button } from '@/components/Button';
import GooglePicker from '@/components/Editor/modals/Data/AddNew/GooglePicker';
import SimpleSpreadsheetLoader from '@/components/SimpleSpreadsheet/Loading';
import GalleryPanel from './Panel';
import { GalleryPanelEnum } from '../settings';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29286 6.29289C7.90234 6.68342 7.90234 7.31658 8.29286 7.70711L12.5858 12L8.29286 16.2929C7.90234 16.6834 7.90234 17.3166 8.29286 17.7071C8.68339 18.0976 9.31655 18.0976 9.70708 17.7071L15.4142 12L9.70708 6.29289C9.31655 5.90237 8.68339 5.90237 8.29286 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FileAddIcon = function FileAddIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_9147_3988)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.3689 3.8835C1.3689 2.55337 1.3689 1.88831 1.62776 1.38027C1.85546 0.933384 2.21878 0.570055 2.66567 0.342356C3.17371 0.0834961 3.83877 0.0834961 5.1689 0.0834961H7.86056C8.08225 0.0834961 8.19309 0.0834961 8.27777 0.126639C8.35225 0.164589 8.4128 0.225144 8.45075 0.299625C8.4939 0.384298 8.4939 0.495142 8.4939 0.716829V2.4585C8.4939 4.2074 9.91166 5.62516 11.6606 5.62516H13.4022C13.6239 5.62516 13.7348 5.62516 13.8194 5.66831C13.8939 5.70626 13.9545 5.76681 13.9924 5.84129C14.0356 5.92596 14.0356 6.03681 14.0356 6.2585V12.1168C14.0356 13.447 14.0356 14.112 13.7767 14.6201C13.549 15.0669 13.1857 15.4303 12.7388 15.658C12.2308 15.9168 11.5657 15.9168 10.2356 15.9168H5.1689C3.83877 15.9168 3.17371 15.9168 2.66567 15.658C2.21878 15.4303 1.85546 15.0669 1.62776 14.6201C1.3689 14.112 1.3689 13.447 1.3689 12.1168V3.8835ZM7.70223 7.2085C8.13945 7.2085 8.4939 7.56294 8.4939 8.00016V8.79183H9.28556C9.72279 8.79183 10.0772 9.14627 10.0772 9.5835C10.0772 10.0207 9.72279 10.3752 9.28556 10.3752H8.4939V11.1668C8.4939 11.6041 8.13945 11.9585 7.70223 11.9585C7.265 11.9585 6.91056 11.6041 6.91056 11.1668V10.3752H6.1189C5.68167 10.3752 5.32723 10.0207 5.32723 9.5835C5.32723 9.14627 5.68167 8.79183 6.1189 8.79183H6.91056V8.00016C6.91056 7.56294 7.265 7.2085 7.70223 7.2085Z",
        fill: "#12131A"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.0771 0.643289C10.0771 0.334124 10.3278 0.0834961 10.6369 0.0834961C10.7854 0.0834961 10.9278 0.142474 11.0328 0.247456L13.8715 3.0862C13.9765 3.19118 14.0355 3.33357 14.0355 3.48204C14.0355 3.7912 13.7849 4.04183 13.4757 4.04183H11.6605C10.786 4.04183 10.0771 3.33295 10.0771 2.4585V0.643289Z",
        fill: "#12131A"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_9147_3988",
        children: /*#__PURE__*/_jsx("rect", {
          width: "14",
          height: "16",
          fill: "white",
          transform: "translate(0.601074)"
        })
      })
    })]
  }));
};

FileAddIcon.defaultProps = {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FileUploadIcon = function FileUploadIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.66675 4.53325C2.66675 3.41315 2.66675 2.85309 2.88473 2.42527C3.07648 2.04895 3.38244 1.74299 3.75877 1.55124C4.18659 1.33325 4.74664 1.33325 5.86675 1.33325H8.13341C8.3201 1.33325 8.41344 1.33325 8.48474 1.36958C8.54747 1.40154 8.59846 1.45253 8.63042 1.51526C8.66675 1.58656 8.66675 1.6799 8.66675 1.86659V3.33325C8.66675 4.80601 9.86065 5.99992 11.3334 5.99992H12.8001C12.9868 5.99992 13.0801 5.99992 13.1514 6.03625C13.2141 6.06821 13.2651 6.1192 13.2971 6.18192C13.3334 6.25323 13.3334 6.34657 13.3334 6.53325V11.4666C13.3334 12.5867 13.3334 13.1467 13.1154 13.5746C12.9237 13.9509 12.6177 14.2569 12.2414 14.4486C11.8136 14.6666 11.2535 14.6666 10.1334 14.6666H5.86675C4.74664 14.6666 4.18659 14.6666 3.75877 14.4486C3.38244 14.2569 3.07648 13.9509 2.88473 13.5746C2.66675 13.1467 2.66675 12.5867 2.66675 11.4666V4.53325ZM7.52868 6.86185C7.78903 6.6015 8.21114 6.6015 8.47149 6.86185L9.80482 8.19518C10.0652 8.45553 10.0652 8.87764 9.80482 9.13799C9.54447 9.39834 9.12236 9.39834 8.86201 9.13799L8.66675 8.94273V11.3333C8.66675 11.7014 8.36827 11.9999 8.00008 11.9999C7.63189 11.9999 7.33341 11.7014 7.33341 11.3333V8.94273L7.13815 9.13799C6.8778 9.39834 6.45569 9.39834 6.19534 9.13799C5.93499 8.87764 5.93499 8.45553 6.19534 8.19518L7.52868 6.86185Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 1.80466C10 1.54431 10.2111 1.33325 10.4714 1.33325C10.5964 1.33325 10.7163 1.38292 10.8047 1.47132L13.1953 3.86185C13.2837 3.95025 13.3333 4.07016 13.3333 4.19518C13.3333 4.45553 13.1223 4.66658 12.8619 4.66658H11.3333C10.597 4.66658 10 4.06963 10 3.33325V1.80466Z",
      fill: "black"
    })]
  }));
};

FileUploadIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var MicrosoftExcelIcon = function MicrosoftExcelIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M360.333 253.667L133.667 213.667V509.227C133.667 522.725 144.609 533.667 158.107 533.667H549.227C562.725 533.667 573.667 522.725 573.667 509.227V400.333L360.333 253.667Z",
      fill: "#185C37"
    }), /*#__PURE__*/_jsx("path", {
      d: "M360.333 0.333252H158.107C144.609 0.333252 133.667 11.2753 133.667 24.7732V133.667L360.333 267L480.333 307L573.667 267V133.667L360.333 0.333252Z",
      fill: "#21A366"
    }), /*#__PURE__*/_jsx("path", {
      d: "M133.667 133.667H360.333V267H133.667V133.667Z",
      fill: "#107C41"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.1",
      d: "M295.893 107H133.667V440.333H295.893C309.373 440.29 320.29 429.373 320.333 415.893V131.44C320.29 117.96 309.373 107.044 295.893 107Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M282.56 120.333H133.667V453.667H282.56C296.04 453.623 306.956 442.706 307 429.227V144.773C306.956 131.294 296.04 120.377 282.56 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M282.56 120.333H133.667V427H282.56C296.04 426.956 306.956 416.04 307 402.56V144.773C306.956 131.294 296.04 120.377 282.56 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M269.227 120.333H133.667V427H269.227C282.706 426.956 293.623 416.04 293.667 402.56V144.773C293.623 131.294 282.706 120.377 269.227 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.7732 120.333H269.226C282.724 120.333 293.666 131.275 293.666 144.773V389.226C293.666 402.724 282.724 413.666 269.226 413.666H24.7732C11.2753 413.667 0.333252 402.724 0.333252 389.227V144.773C0.333252 131.275 11.2753 120.333 24.7732 120.333Z",
      fill: "url(#paint0_linear_1_40)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M76.0266 346.44L127.44 266.773L80.3333 187.547H118.227L143.933 238.213C146.307 243.027 147.933 246.6 148.813 248.96H149.147C150.808 245.177 152.587 241.446 154.48 237.773L181.96 187.573H216.746L168.44 266.333L217.973 346.44H180.96L151.267 290.827C149.868 288.461 148.681 285.975 147.72 283.4H147.28C146.41 285.923 145.256 288.338 143.84 290.6L113.267 346.44H76.0266Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M549.227 0.333252H360.333V133.667H573.667V24.7732C573.667 11.2753 562.725 0.333252 549.227 0.333252Z",
      fill: "#33C481"
    }), /*#__PURE__*/_jsx("path", {
      d: "M360.333 267H573.667V400.333H360.333V267Z",
      fill: "#107C41"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1_40",
        x1: "51.2911",
        y1: "101.236",
        x2: "242.709",
        y2: "432.763",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#18884F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5",
          stopColor: "#117E43"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#0B6631"
        })]
      })
    })]
  }));
};

MicrosoftExcelIcon.defaultProps = {
  width: "574",
  height: "534",
  viewBox: "0 0 574 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var GoogleSheetsIcon = function GoogleSheetsIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M271.25 0H40.6875C18.3094 0 0 16.3841 0 36.4091V497.591C0 517.616 18.3094 534 40.6875 534H393.312C415.69 534 434 517.616 434 497.591V145.636L339.062 84.9545L271.25 0Z",
      fill: "#0F9D58"
    }), /*#__PURE__*/_jsx("path", {
      d: "M108.5 260.932V436.909H325.5V260.932H108.5ZM203.438 412.637H135.625V382.296H203.438V412.637ZM203.438 364.091H135.625V333.75H203.438V364.091ZM203.438 315.546H135.625V285.205H203.438V315.546ZM298.375 412.637H230.563V382.296H298.375V412.637ZM298.375 364.091H230.563V333.75H298.375V364.091ZM298.375 315.546H230.563V285.205H298.375V315.546Z",
      fill: "#F1F1F1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M271.249 0V109.227C271.249 129.343 289.457 145.636 311.936 145.636H433.999L271.249 0Z",
      fill: "#87CEAC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.6875 0C18.3094 0 0 16.3841 0 36.4091V39.4432C0 19.4182 18.3094 3.03409 40.6875 3.03409H271.25V0H40.6875Z",
      fill: "white",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M393.312 530.965H40.6875C18.3094 530.965 0 514.581 0 494.556V497.59C0 517.615 18.3094 534 40.6875 534H393.312C415.69 534 434 517.615 434 497.59V494.556C434 514.581 415.69 530.965 393.312 530.965Z",
      fill: "#263238",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M311.936 145.636C289.457 145.636 271.249 129.343 271.249 109.227V112.261C271.249 132.377 289.457 148.67 311.936 148.67H433.999V145.636H311.936Z",
      fill: "#263238",
      fillOpacity: "0.1"
    })]
  }));
};

GoogleSheetsIcon.defaultProps = {
  width: "434",
  height: "534",
  viewBox: "0 0 434 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var AiIcon = function AiIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M17 8C17.5523 8 18 7.55228 18 7V6H19C19.5523 6 20 5.55228 20 5C20 4.44772 19.5523 4 19 4H18V3C18 2.44772 17.5523 2 17 2C16.4477 2 16 2.44772 16 3V4L15 4C14.4477 4 14 4.44772 14 5C14 5.55228 14.4477 6 15 6H16L16 7C16 7.55228 16.4477 8 17 8Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17 22C17.5523 22 18 21.5523 18 21V20H19C19.5523 20 20 19.5523 20 19C20 18.4477 19.5523 18 19 18H18V17C18 16.4477 17.5523 16 17 16C16.4477 16 16 16.4477 16 17V18H15C14.4477 18 14 18.4477 14 19C14 19.5523 14.4477 20 15 20H16L16 21C16 21.5523 16.4477 22 17 22Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.4065 7.19789C11.1514 5.59802 8.84879 5.59802 8.59365 7.19789C8.31512 8.9445 6.94543 10.3143 5.19888 10.5928C3.59909 10.848 3.59905 13.1504 5.19888 13.4056C6.94542 13.6842 8.31512 15.0539 8.59365 16.8006C8.84878 18.4004 11.1514 18.4004 11.4065 16.8006C11.6851 15.0539 13.0547 13.6842 14.8013 13.4056C16.4011 13.1504 16.4011 10.848 14.8013 10.5928C13.0547 10.3143 11.6851 8.9445 11.4065 7.19789Z",
      fill: "#C3C9D1"
    })]
  }));
};

AiIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var NewWindowIcon = function NewWindowIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.33333 3.33333C4.22876 3.33333 3.33333 4.22876 3.33333 5.33333V10.6667C3.33333 11.7712 4.22876 12.6667 5.33333 12.6667H10.6667C11.7712 12.6667 12.6667 11.7712 12.6667 10.6667V8.66667C12.6667 8.29848 12.9651 8 13.3333 8C13.7015 8 14 8.29848 14 8.66667V10.6667C14 12.5076 12.5076 14 10.6667 14H5.33333C3.49238 14 2 12.5076 2 10.6667V5.33333C2 3.49238 3.49238 2 5.33333 2H7.33333C7.70152 2 8 2.29848 8 2.66667C8 3.03486 7.70152 3.33333 7.33333 3.33333H5.33333Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.6667 5.33333C12.6667 5.70152 12.9651 6 13.3333 6C13.7015 6 14 5.70152 14 5.33333V2.66667C14 2.29848 13.7015 2 13.3333 2H10.6667C10.2985 2 10 2.29848 10 2.66667C10 3.03486 10.2985 3.33333 10.6667 3.33333L11.7239 3.33333L7.33333 7.72386V6.66667C7.33333 6.29848 7.03486 6 6.66667 6C6.29848 6 6 6.29848 6 6.66667V9.33333C6 9.70152 6.29848 10 6.66667 10H9.33333C9.70152 10 10 9.70152 10 9.33333C10 8.96514 9.70152 8.66667 9.33333 8.66667H8.27614L12.6667 4.27614V5.33333Z",
      fill: "#12131A"
    })]
  }));
};

NewWindowIcon.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var FloppyDiskIcon = function FloppyDiskIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.33331 11.6667C7.87308 11.6667 7.49998 12.0398 7.49998 12.5V16.6667H5.83331V12.5C5.83331 11.1193 6.9526 10 8.33331 10H11.6666C13.0474 10 14.1666 11.1193 14.1666 12.5V16.6667H12.5V12.5C12.5 12.0398 12.1269 11.6667 11.6666 11.6667H8.33331Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5 5.83331V3.33331H10.8333V5.83331C10.8333 6.29355 10.4602 6.66665 9.99998 6.66665H8.33331C7.87308 6.66665 7.49998 6.29355 7.49998 5.83331V3.33331H5.83331V5.83331C5.83331 7.21402 6.9526 8.33331 8.33331 8.33331H9.99998C11.3807 8.33331 12.5 7.21403 12.5 5.83331Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.5362 4.23578C12.2708 4.17206 11.9792 4.1667 11.1242 4.1667H8.66667C7.7195 4.1667 7.05924 4.16735 6.5452 4.20935C6.04089 4.25055 5.75115 4.32736 5.53169 4.43919C5.06129 4.67887 4.67883 5.06132 4.43915 5.53173C4.32733 5.75119 4.25052 6.04093 4.20931 6.54524C4.16732 7.05927 4.16667 7.71953 4.16667 8.6667V11.3334C4.16667 12.2805 4.16732 12.9408 4.20931 13.4548C4.25052 13.9591 4.32733 14.2489 4.43915 14.4683C4.67883 14.9388 5.06129 15.3212 5.53169 15.5609C5.75115 15.6727 6.04089 15.7495 6.5452 15.7907C7.05924 15.8327 7.7195 15.8334 8.66667 15.8334H11.3333C12.2805 15.8334 12.9408 15.8327 13.4548 15.7907C13.9591 15.7495 14.2488 15.6727 14.4683 15.5609C14.9387 15.3212 15.3212 14.9388 15.5609 14.4683C15.6727 14.2489 15.7495 13.9591 15.7907 13.4548C15.8327 12.9408 15.8333 12.2805 15.8333 11.3334V8.87584C15.8333 8.02087 15.828 7.72921 15.7643 7.4638C15.703 7.20871 15.602 6.96485 15.4649 6.74117C15.3223 6.50844 15.1199 6.29841 14.5153 5.69386L14.3062 5.48472C13.7016 4.88017 13.4916 4.67772 13.2589 4.5351C13.0352 4.39803 12.7913 4.29702 12.5362 4.23578ZM11.2192 2.50002C11.9431 2.49981 12.4442 2.49966 12.9253 2.61516C13.3505 2.71723 13.7569 2.88558 14.1297 3.11403C14.5515 3.37254 14.9058 3.72699 15.4175 4.23904C15.4396 4.26114 15.462 4.28353 15.4847 4.30621L15.6938 4.51535C15.7165 4.53803 15.7389 4.5604 15.761 4.58248C16.273 5.09424 16.6275 5.44849 16.886 5.87034C17.1145 6.24314 17.2828 6.64957 17.3849 7.07473C17.5004 7.55581 17.5002 8.05693 17.5 8.78089C17.5 8.81212 17.5 8.84377 17.5 8.87584V11.3691C17.5 12.2722 17.5 13.0007 17.4518 13.5906C17.4022 14.1979 17.2973 14.7314 17.0459 15.225C16.6464 16.009 16.009 16.6464 15.225 17.0459C14.7314 17.2974 14.1979 17.4022 13.5905 17.4519C13.0006 17.5001 12.2722 17.5 11.369 17.5H8.63097C7.72783 17.5 6.99937 17.5001 6.40948 17.4519C5.80211 17.4022 5.26862 17.2974 4.77504 17.0459C3.99103 16.6464 3.35361 16.009 2.95414 15.225C2.70265 14.7314 2.59781 14.1979 2.54818 13.5906C2.49999 13.0007 2.49999 12.2722 2.5 11.369V8.63103C2.49999 7.72788 2.49999 6.99941 2.54818 6.40952C2.59781 5.80214 2.70265 5.26865 2.95414 4.77508C3.35361 3.99107 3.99103 3.35365 4.77504 2.95418C5.26862 2.70269 5.80211 2.59784 6.40948 2.54822C6.99938 2.50002 7.72784 2.50003 8.631 2.50004L11.1242 2.50004C11.1563 2.50004 11.1879 2.50003 11.2192 2.50002Z",
      fill: "black"
    })]
  }));
};

FloppyDiskIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const SimpleSpreadsheet = dynamic(() => import('@/components/SimpleSpreadsheet'), {
  ssr: false,
  loading: () => /*#__PURE__*/_jsx(SimpleSpreadsheetLoader, {}),
  loadableGenerated: {
    webpack: () => [require.resolveWeak('@/components/SimpleSpreadsheet')]
  }
});
const DATA_EDITOR_PANEL_WIDTH = 354;
const SUPPORT_GOOGLE_PICKER = featureFlags.googlePicker;

const DataEditorPanel = _ref => {
  let {
    nameSpace,
    user,
    isMobileOrTablet,
    isDataGenerating = false,
    workbookData,
    workbookErrors,
    dataEditorColumnStructure,
    selectGalleryItem,
    getGoogleDriveFile,
    onChangeGoogleDriveFile,
    onChangeWorkbookData,
    onSwitchEditingMode,
    onAiGenerate,
    onSave,
    onCloseGalleryPanel
  } = _ref;
  const isFirstTimeChange = useRef(true);
  const {
    0: isFooterCollapsed,
    1: setIsFooterCollapsed
  } = useState(Boolean(userInteractions.findValue('dataEditorFooterCollapsed')));
  const handleFooterCollapseStateChange = useCallback(isCollapsed => {
    setIsFooterCollapsed(isCollapsed);
    userInteractions.saveValue('dataEditorFooterCollapsed', isCollapsed); // Update the flag to keep the footer visible when the data changes
    // for the first time after the user has collapsed it.

    isFirstTimeChange.current = false;
  }, []);
  const handleWorkbookDataChange = useCallback(data => {
    // Hide the footer when the data changes for the first time.
    const isCollapsedByUser = userInteractions.findValue('dataEditorFooterCollapsed');

    if (isFirstTimeChange.current && isCollapsedByUser !== true) {
      isFirstTimeChange.current = false;
      handleFooterCollapseStateChange(true);
      return;
    }

    if (onChangeWorkbookData) {
      onChangeWorkbookData(data);
    }
  }, [onChangeWorkbookData, handleFooterCollapseStateChange]);
  return /*#__PURE__*/_jsx(ClientOnly, {
    children: /*#__PURE__*/_jsx(GalleryPanel, {
      nameSpace: nameSpace,
      title: "Data Editor",
      description: /*#__PURE__*/_jsx(_Fragment, {
        children: "Use this editor for simple data, or enabled advanced mode for custom spreadsheets."
      }),
      isResizeable: true,
      collapsibleFooter: true,
      isFooterCollapsed: isFooterCollapsed,
      isMobile: isMobileOrTablet,
      className: styles.dataEditorPanel,
      classNames: {
        panelContent: styles.dataEditorContent,
        panelFooter: styles.dataEditorFooter
      },
      panelWidth: DATA_EDITOR_PANEL_WIDTH,
      headingActions: /*#__PURE__*/_jsx(DataEditorQuickActions, _objectSpread({
        isDataGenerating: isDataGenerating,
        onUpload: () => {
          onCloseGalleryPanel();
          selectGalleryItem(GalleryPanelEnum.UPLOAD);
        },
        onAiGenerate: onAiGenerate
      }, !user && {
        onSave: () => {
          onCloseGalleryPanel();
          onSave();
        }
      })),
      footer: /*#__PURE__*/_jsx(DataEditorActions, _objectSpread({
        isDataGenerating: isDataGenerating,
        getGoogleDriveFile: getGoogleDriveFile,
        onChangeGoogleDriveFile: onChangeGoogleDriveFile,
        onUpload: () => {
          onCloseGalleryPanel();
          selectGalleryItem(GalleryPanelEnum.UPLOAD);
        },
        onAiGenerate: onAiGenerate
      }, typeof onSwitchEditingMode === 'function' && {
        onSwitchEditingMode: () => {
          onCloseGalleryPanel();
          onSwitchEditingMode('advanced');
        }
      })),
      onFooterCollapseStateChange: handleFooterCollapseStateChange,
      onClose: onCloseGalleryPanel,
      children: workbookData ? /*#__PURE__*/_jsx(SimpleSpreadsheet, {
        editable: true,
        nameSpace: nameSpace,
        data: workbookData,
        errors: workbookErrors,
        columnStructure: dataEditorColumnStructure,
        onChange: handleWorkbookDataChange
      }) : null
    })
  });
};

const DataEditorQuickActions = _ref2 => {
  let {
    isDataGenerating,
    onAiGenerate,
    onUpload,
    onSave
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.dataEditorQuickActions,
    children: [/*#__PURE__*/_jsx(Button, {
      className: styles.quickAction,
      variant: "pill",
      size: "small",
      disabled: isDataGenerating,
      leftIcon: /*#__PURE__*/_jsx(FileUploadIcon, {}),
      onClick: onUpload
    }), onAiGenerate ? /*#__PURE__*/_jsx(Button, {
      className: styles.quickAction,
      variant: "pill",
      size: "small",
      leftIcon: isDataGenerating ? /*#__PURE__*/_jsx(CircularProgress, {
        size: 16,
        color: "inherit"
      }) : /*#__PURE__*/_jsx(AiIcon, {}),
      disabled: isDataGenerating,
      onClick: onAiGenerate
    }) : null, onSave ? /*#__PURE__*/_jsx(Button, {
      className: styles.quickAction,
      variant: "pill",
      size: "small",
      disabled: isDataGenerating,
      leftIcon: /*#__PURE__*/_jsx(FloppyDiskIcon, {}),
      onClick: onSave,
      children: "Save"
    }) : null]
  });
};

const DataEditorActions = _ref3 => {
  let {
    isDataGenerating,
    getGoogleDriveFile,
    onUpload,
    onAiGenerate,
    onChangeGoogleDriveFile,
    onSwitchEditingMode
  } = _ref3;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: clsx(styles.footerActions, styles.dataEditorFooterActions),
      children: [/*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "pill",
        className: "w-full",
        classNames: {
          icon: styles.iconsSet
        },
        disabled: isDataGenerating,
        rightIcon: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(MicrosoftExcelIcon, {}), /*#__PURE__*/_jsx(GoogleSheetsIcon, {}), /*#__PURE__*/_jsx(FileAddIcon, {})]
        }),
        onClick: onUpload,
        children: "Upload"
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "pill",
        className: "w-full",
        rightIcon: isDataGenerating ? /*#__PURE__*/_jsx(CircularProgress, {
          size: 16,
          color: "inherit"
        }) : /*#__PURE__*/_jsx(AiIcon, {}),
        disabled: isDataGenerating,
        onClick: onAiGenerate,
        children: "AI Generate"
      }), SUPPORT_GOOGLE_PICKER ? /*#__PURE__*/_jsx(GooglePicker, {
        getGoogleDriveFile: getGoogleDriveFile,
        onChange: onChangeGoogleDriveFile
      }) : null]
    }), onSwitchEditingMode ? /*#__PURE__*/_jsx(Button, {
      type: "button",
      variant: "secondary",
      size: "small",
      className: styles.advancedDataEditorButton,
      rightIcon: /*#__PURE__*/_jsx(ArrowRightIcon, {}),
      leftIcon: /*#__PURE__*/_jsx(NewWindowIcon, {}),
      onClick: onSwitchEditingMode,
      children: "Advanced Data Editor"
    }) : null]
  });
};

export default DataEditorPanel;